module.exports = __webpack_public_path__ + "static/media/img-e91bd4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/png/black.png
// module id = 5261
// module chunks = 39